var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Пользовательское соглашение")]),_c('p',[_vm._v("Текст пользовательского соглашения")])])}]

export { render, staticRenderFns }